import { useFormContext } from '@calendly/form';
import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconButton } from '@calendly/ui/components/icon-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import { Modal } from '@calendly/ui/components/modal';
import { BodyText } from '@calendly/ui/components/typography';
import { useMemo, useState, useRef } from 'react';
import { useEventType } from 'features/event_type_provider';
import { FormCurrencyField } from './form_currency_field';
const modalContentCss = "mppi45q";
const modalHeaderCss = "m1qpkc2p";
const discountCodesListCss = "dwe7ehx";
const discountCodeItemCss = "dwb82se";
const buttonContainerCss = "b1txyyw0";
export const PaymentAmount = ({
  label = I18n.t('publisher.event_types.payment_method.amount_to_collect'),
  newForm = false,
  coupons = [],
  onDeleteCoupon,
  onCurrencyChange
}) => {
  const eventType = useEventType();
  const {
    values,
    setFieldValue
  } = useFormContext();
  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const [isDeletingCoupons, setIsDeletingCoupons] = useState(false);
  const originalCurrency = useRef(values.currency);

  // Filter fixed amount coupons that will be affected by currency change
  const fixedAmountCoupons = useMemo(() => coupons.filter(coupon => coupon.bookingCodeType === 'FIXED' && coupon.fixedAmountCents), [coupons]);
  const handleCloseModal = () => {
    // Revert currency back to original value when modal is closed without confirmation
    setFieldValue('currency', originalCurrency.current);
    setShowCurrencyModal(false);
  };
  const handleUpdateCurrency = async () => {
    try {
      setIsDeletingCoupons(true);

      // Delete all fixed amount coupons
      if (onDeleteCoupon && fixedAmountCoupons.length > 0) {
        await Promise.all(fixedAmountCoupons.map(coupon => onDeleteCoupon(coupon.uuid)));
      }
      originalCurrency.current = values.currency;
      setShowCurrencyModal(false);
    } catch (error) {
      console.error('Failed to delete coupons:', error);
      setFieldValue('currency', originalCurrency.current);
    } finally {
      setIsDeletingCoupons(false);
    }
  };
  useOnValueChange(values.currency, () => {
    if (newForm && eventType?.id && originalCurrency.current !== values.currency && fixedAmountCoupons.length > 0) {
      setShowCurrencyModal(true);
    } else {
      originalCurrency.current = values.currency;
    }
    if (onCurrencyChange) {
      onCurrencyChange(values.currency);
    }
  });
  return <>
      <FormCurrencyField id="payment-amount-field" amountFieldName="amount" currencyFieldName="currency" onCurrencyChange={onCurrencyChange} label={label} />

      <Modal isOpen={showCurrencyModal} onClose={handleCloseModal}>
        <div className={modalContentCss}>
          <div className={modalHeaderCss}>
            <span>
              {I18n.t('publisher.event_types.payment_method.change_currency_title', {
              currency: values.currency
            })}
            </span>
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </div>

          <BodyText>
            {I18n.t('publisher.event_types.payment_method.change_currency_description_start')}
            {' '}
            <strong>{I18n.t('publisher.event_types.payment_method.change_currency_description_bold')}</strong>
            {I18n.t('publisher.event_types.payment_method.change_currency_description_end')}
          </BodyText>

          <ul className={discountCodesListCss}>
            {fixedAmountCoupons.map(coupon => <li key={coupon.uuid} className={discountCodeItemCss}>
                {coupon.code}
              </li>)}
          </ul>

          <div className={buttonContainerCss}>
            <Button wide decoration="secondary-outline" onClick={handleCloseModal}>
              {I18n.t('publisher.event_types.payment_method.cancel')}
            </Button>
            <Button autoFocus wide onClick={handleUpdateCurrency} loading={isDeletingCoupons} disabled={isDeletingCoupons}>
              {I18n.t('publisher.event_types.payment_method.update_and_remove_codes')}
            </Button>
          </div>
        </div>
      </Modal>
    </>;
};

require("./payment_amount.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_amount.js");